const htmlEncode = (html) => {
    return html.replace(/[\u00A0-\u9999<>\&]/g, function (i) {
        return '&#' + i.charCodeAt(0) + ';';
    });
};
const htmlDecode = (str) => {
    const e = document.createElement('textarea');
    e.innerHTML = str;
    return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
};

export { htmlDecode, htmlEncode };
